import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
// Material
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Fade from "@material-ui/core/Fade";
// Component
import ProductListItem from "./../ProductListItem/ProductListItem";
// Styles
import useStyles from "./CategoryItem.style.js";
import {
  Box,
  Button,
  ButtonGroup,
  FormControl,
  MenuItem,
  Select,
} from "@material-ui/core";
import { SORTS, SORT_OPTIONS_SUB } from "../../utils/Constants";
import useSortHook from "../../CustomHooks/useSortHook";
import moment from "moment";
import { isString } from "lodash";
import { setActiveCategory } from "../../store/Menu/MenuActions.js";
import ProductItemList from "../PorudctItemList/ProductItemList";

const CategoryItem = React.memo(
  ({ category, onProductclick = () => {}, className }) => {
    // const CategoryItem = ({ category, onProductclick = () => {}, className }) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const categoryRef = useRef(null);
    const {
      searchPhrase,
      selectedCategory,
      sortedCategoryMenu,
      activeCategory,
    } = useSelector((state) => state.menu);
    const { hotel } = useSelector((state) => state.hotel);
    const [subCategory, setSubCategory] = useState(``);
    const { checkoutDetails } = useSelector((state) => state.cart);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [sortType, setSortType] = useState(SORTS.DEFAULT);
    const {
      formatDateToCheck,
      checkProductAvailability,
      checkCategoryAvailibility,
      getNextAvailableTime,
    } = useSortHook();
    const { handleSortCategory } = useSortHook();
    const [currentTime, setCurrentTime] = useState(moment());
    const [visibleItems, setVisibleItems] = useState([]);
    const [initialRenderComplete, setInitialRenderComplete] = useState(false);

    // Update current time every second
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentTime(moment());
      }, 1000);

      return () => clearInterval(interval);
    }, []);

    const handleSortChange = (e) => {
      const val = e.target.value;
      setSortType(val);
      handleSortCategory(val, category.categoryId);
    };

    useEffect(() => {
      setSortType(SORTS.DEFAULT);
    }, [searchPhrase]);

    const uniqueArray = category?.item?.reduce((accumulator, current) => {
      const exists = accumulator.some(
        (item) => item?.sub_cat_id === current?.sub_cat_id
      );

      if (!exists) {
        accumulator.push(current);
      }
      return accumulator;
    }, []);

    useEffect(() => {
      if (uniqueArray && subCategory === `` && category?.item) {
        setSubCategory(0);
      }
    }, [uniqueArray, subCategory, category?.item]);

    useEffect(() => {
      if (subCategory !== 0 && category?.item) {
        const filteredProduct = category?.item?.filter(
          (prod) => prod?.sub_cat_id === subCategory
        );
        setFilteredProducts(filteredProduct);
      } else if (subCategory === 0) {
        setFilteredProducts(category?.item);
      } else {
        setFilteredProducts(category?.item);
      }
    }, [subCategory, category?.item, category?.sub_categories]);

    const sortedItems = [...(filteredProducts || [])].sort((a, b) => {
      const positionA =
        a.position === undefined ? Number.MAX_SAFE_INTEGER : a.position;
      const positionB =
        b.position === undefined ? Number.MAX_SAFE_INTEGER : b.position;

      return positionA - positionB;
    });

    // Set top 10 items for initial render
    // useEffect(() => {
    //   console.log("working 11111111111");

    //   setVisibleItems(sortedItems.slice(0, 10));
    // }, [sortedItems]);

    // // Render remaining items after initial render
    // useEffect(() => {
    //   if (initialRenderComplete) {
    //     console.log("working 2222222222");
    //     const timeout = setTimeout(() => {
    //       setVisibleItems(sortedItems);
    //     }, 0);
    //     return () => clearTimeout(timeout);
    //   }
    // }, [initialRenderComplete, sortedItems]);

    // // Track when the initial render is complete
    // useEffect(() => {
    //   if (visibleItems.length > 0 && visibleItems.length <= 10) {
    //     console.log("working 33333333333");

    //     setInitialRenderComplete(true);
    //   }
    // }, [visibleItems]);

    const getValidInactiveReason = (categoryReason, itemReason) => {
      return categoryReason && categoryReason !== "null"
        ? categoryReason
        : itemReason && itemReason !== "null"
        ? itemReason
        : undefined;
    };

    return (
      <div ref={categoryRef} className={classes.root}>
        <Fade in={true}>
          <div className={classes.titleContainer}>
            <div className={className}>
              <Typography className={classes.title} variant="h2" noWrap>
                {category.label}
              </Typography>
            </div>
          </div>
        </Fade>

        <Fade in={true}>
          <Typography className={classes.desc} variant="body1">
            {category?.description}
          </Typography>
        </Fade>
        {uniqueArray?.length > 1 && (
          <div>
            <div className={classes.radioDiv}>
              <ButtonGroup>
                {uniqueArray?.length > 0 &&
                  [
                    { sub_cat_id: 0, sub_cat_name: "All" },
                    ...uniqueArray.sort(
                      (a, b) => a?.sub_cat_position - b?.sub_cat_position
                    ),
                  ]
                    .filter((s) => s?.sub_cat_name)
                    .map((s) =>
                      s?.sub_cat_id != null ? (
                        <Box
                          key={s?.sub_cat_id}
                          className={classes.buttonWrapper}
                        >
                          <Button
                            className={classes.subCatgeoryBtn}
                            defaultValue={subCategory}
                            variant={
                              subCategory === s?.sub_cat_id
                                ? "contained"
                                : "outlined"
                            }
                            onClick={() => setSubCategory(s?.sub_cat_id)}
                          >
                            {s?.sub_cat_name}
                          </Button>
                        </Box>
                      ) : null
                    )}
              </ButtonGroup>
            </div>
          </div>
        )}
        <div className={classes.productListContainer}>
          <Grid container spacing={2}>
            {sortedItems
              ?.sort((a, b) => a?.sub_cat_position - b?.sub_cat_position)
              .map((item, i) => (
                <Grid item xs={12} sm={6} key={i}>
                  <ProductListItem
                    disabled={category.inactive ? true : false}
                    item={item}
                    onClick={(e) =>
                      onProductclick(e, category.addOnIds, category)
                    }
                    inActive={
                      !checkProductAvailability(
                        item,
                        checkoutDetails?.deliveryType === "ASAP"
                          ? currentTime.toDate()
                          : formatDateToCheck(checkoutDetails?.deliveryTime)
                      ) ||
                      !checkProductAvailability(
                        category,
                        checkoutDetails?.deliveryType === "ASAP"
                          ? currentTime.toDate()
                          : formatDateToCheck(checkoutDetails?.deliveryTime)
                      ) ||
                      category?.inactive ||
                      item?.is_inactive
                    }
                    inActiveReason={getValidInactiveReason(
                      category.inactive_reason,
                      item.inactive_reason
                    )}
                  />
                </Grid>
              ))}
          </Grid>
        </div>
      </div>
    );
  }
);

export default CategoryItem;
